import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject, Signal, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { IconComponent } from '@libs/components/icons';
import { NavItemModel, NavModel } from '@libs/shared/models';
import { NavigationService } from '@libs/shared/services';
import { NavLinkDirective } from '@libs/shared/ui';
import { HoverMenuComponent } from '../menus/hover-menu';

@Component({
  selector: 'ui-desktop-navigation',
  imports: [NgTemplateOutlet, MatButtonModule, NavLinkDirective, HoverMenuComponent, IconComponent],
  templateUrl: './desktop-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './desktop-navigation.component.scss',
})
export class DesktopNavigationComponent {
  private readonly navigationService: NavigationService = inject(NavigationService);

  public readonly mainNavigation: Signal<NavModel | undefined> = toSignal(
    this.navigationService.getMainNavigation(),
    { initialValue: undefined },
  );

  public readonly items: Signal<readonly NavItemModel[]> = computed(
    (): readonly NavItemModel[] => this.mainNavigation()?.children ?? [],
  );
}
